"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NumStepper", {
  enumerable: true,
  get: function get() {
    return _numStepper.default;
  }
});
exports.default = void 0;

require("core-js/modules/es6.function.name.js");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _bindAll2 = _interopRequireDefault(require("lodash/bindAll"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _baseStepper = _interopRequireWildcard(require("./base-stepper"));

var _numStepper = _interopRequireDefault(require("./num-stepper"));

var Stepper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Stepper, _React$Component);

  var _super = (0, _createSuper2.default)(Stepper);

  // TODO determine more appropriate PropTypes so that lint does not have to be disabled
  function Stepper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Stepper);
    _this = _super.call(this, props);
    _this.state = {
      selectedIndex: Math.max((0, _findIndex2.default)(props.range, {
        value: props.value
      }), 0)
    };
    (0, _bindAll2.default)((0, _assertThisInitialized2.default)(_this), ['isHandleDisabled', 'handleStep', 'getDisplayValue']);
    return _this;
  } // eslint-disable-next-line react/no-deprecated -- directive added automatically by Shepherd migration


  (0, _createClass2.default)(Stepper, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // In case we receive new props - map it back to the state.
      this.setState({
        selectedIndex: Math.max((0, _findIndex2.default)(nextProps.range, {
          value: nextProps.value
        }), 0)
      });
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      return this.props.range[this.state.selectedIndex].name;
    }
  }, {
    key: "handleStep",
    value: function handleStep(direction, isIntermediate) {
      var range = this.props.range;
      var min = 0;
      var max = range.length - 1;
      var selectedIndex = this.state.selectedIndex;
      var newIndex = Math.min(Math.max(min, selectedIndex + direction), max); // Don't trigger intermediate calls to the user.

      if (!isIntermediate) {
        this.props.onChange(range[newIndex], range[selectedIndex]);
      } else {
        // Update the state in case the props weren't changing.
        this.setState({
          selectedIndex: newIndex
        });
      }
    }
  }, {
    key: "isHandleDisabled",
    value: function isHandleDisabled(direction) {
      if (direction === _baseStepper.ENUM_LEFT) {
        return this.state.selectedIndex === 0;
      }

      if (direction === _baseStepper.ENUM_RIGHT) {
        return this.state.selectedIndex === this.props.range.length - 1;
      }

      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('NW Stepper - Invalid direction provided.');
      } // Let it be enabled by default


      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.props), {}, {
        onHandleChange: this.handleStep,
        value: this.getDisplayValue(),
        isHandleDisabled: this.isHandleDisabled
      });
      return /*#__PURE__*/_react.default.createElement(_baseStepper.default, props);
    }
  }]);
  return Stepper;
}(_react.default.Component);

exports.default = Stepper;
(0, _defineProperty2.default)(Stepper, "displayName", 'Stepper');
(0, _defineProperty2.default)(Stepper, "propTypes", {
  onChange: _propTypes.default.func,
  range: _propTypes.default.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  value: _propTypes.default.any // eslint-disable-line react/forbid-prop-types, react/require-default-props

});
(0, _defineProperty2.default)(Stepper, "defaultProps", {
  onChange: function onChange() {}
});